module.exports = __webpack_public_path__ + "media/images/icons/teal-dotted-underline-15b0a5bbbef76e4ad4d180bed4406cd9.svg";